import { TREATMENT_OPTIONS_TYPE } from '../common/constants/treatmentOptions'

export enum FavoritedProvidersCardState {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
}

export type FavoritedProviderIdRecordsResponse = {
  createDateUnixTimestamp: number
  providerLyraId: string
  searchId: string
  userFavoriteProviderRequestId: string
  treatmentPreference: TREATMENT_OPTIONS_TYPE | ''
}

/* Group related props for the provider cards on Favorited Providers Page */
export type FavoritedProvidersPageCardsRouteProps = {
  favoritedProvidersMsUntilExpiration: number
  favoritedProvidersCardState: FavoritedProvidersCardState
}

export type FavoritedProvidersMetadata = Omit<FavoritedProviderIdRecordsResponse, 'providerLyraId'>

export type FavoritedProvidersSaveEventPayload = {
  isFavorited: boolean
  lyraId: string
  providerId: string
  treatmentPreference: TREATMENT_OPTIONS_TYPE | ''
  searchId: string
  userFavoriteProviderRequestId: string
}

export enum FavoritedProviderProfilesFetchStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  DONE = 'done',
}

export enum FavoritedProvidersValidationAction {
  REFINED_FAVORITES = 'REFINED_FAVORITES',
  ALL_PROVIDERS_CLEARED = 'ALL_PROVIDERS_CLEARED',
  NONE = 'NONE',
}
